import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

export type UseCase = 'logistics' | 'emergency';

interface UseCaseContextType {
  useCase: UseCase;
  setUseCase: (useCase: UseCase) => void;
}

const UseCaseContext = createContext<UseCaseContextType | undefined>(undefined);

const STORAGE_KEY = 'zecure-use-case';

export function UseCaseProvider({ children }: { children: ReactNode }) {
  // Load from localStorage or default to 'logistics'
  const [useCase, setUseCase] = useState<UseCase>(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === 'logistics' || saved === 'emergency') {
        return saved;
      }
    } catch {
      // Ignore localStorage errors
    }
    return 'logistics';
  });

  // Persist to localStorage when use case changes
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, useCase);
    } catch {
      // Ignore localStorage errors
    }
  }, [useCase]);

  return (
    <UseCaseContext.Provider value={{ useCase, setUseCase }}>
      {children}
    </UseCaseContext.Provider>
  );
}

export function useUseCase() {
  const context = useContext(UseCaseContext);
  if (context === undefined) {
    throw new Error('useUseCase must be used within a UseCaseProvider');
  }
  return context;
}

